import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "illustration", "illustrationProps", "title"];
import { isValidElement } from 'react';
import styled from 'foundations-theming/utils';
import { Illustration } from '../../components/Illustration/Illustration';
import { Section } from '../../components/Section/Section';
import { Text } from '../../../components/Text/Text';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { View } from '../../../components/View/View';
import { lazyEval } from '../../utils/lazyEval';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultIllustrationProps = {
  width: 175
};
const renderTitle = title => {
  if ( /*#__PURE__*/isValidElement(title)) return title;
  return /*#__PURE__*/_jsx(Text, {
    as: "h2",
    children: lazyEval(title)
  });
};
const Outer = styled.div.withConfig({
  displayName: "ResultsMessage__Outer",
  componentId: "sc-1g4gbxa-0"
})(({
  $cssStyles
}) => {
  return Object.assign({
    textAlign: 'center'
  }, $cssStyles);
});
export const ResultsMessage = _ref => {
  let {
      children,
      illustration,
      illustrationProps = defaultIllustrationProps,
      title
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(Outer, Object.assign({
    role: "alert",
    $cssStyles: cssStyles
  }, domProps, {
    children: /*#__PURE__*/_jsxs(Section, {
      use: "island",
      children: [illustration && /*#__PURE__*/_jsx(Illustration, Object.assign({
        name: illustration,
        marginBlockEnd: "500"
      }, illustrationProps)), title && /*#__PURE__*/_jsx(View, {
        paddingBlockEnd: "400",
        children: renderTitle(title)
      }), /*#__PURE__*/_jsx("div", {
        children: children
      })]
    })
  }));
};